/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iotex_Chain_Tps_ExplanationInputs */



/**
* | output |
* | --- |
* | "GrantReward" |
*
* @param {Iotex_Chain_Tps_ExplanationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const iotex_chain_tps_explanation = /** @type {((inputs?: Iotex_Chain_Tps_ExplanationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iotex_Chain_Tps_ExplanationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("GrantReward")
});